// ── Préférences audio (écoute / TTS) ──────────────────────────────────────────

const LS_PREFS_AUDIO = 'usito.prefs.audio';

/** Les 4 origines où l'icône d'écoute peut apparaître (cf. data-audio-origine). */
export const ORIGINES_AUDIO = ['recherche', 'lexies', 'exemples', 'mots'];

/**
 * Lit les préférences audio depuis localStorage.
 * Chaque origine est ACTIVÉE PAR DÉFAUT (true) si absente : on ne persiste que les
 * désactivations explicites, ce qui préserve le comportement existant.
 * @returns {{recherche:boolean, lexies:boolean, exemples:boolean, mots:boolean}}
 */
export function lirePrefsAudio() {
    let brut = {};
    try {
        brut = JSON.parse(localStorage.getItem(LS_PREFS_AUDIO)) || {};
    } catch (e) {
        brut = {};
    }
    const prefs = {};
    for (const origine of ORIGINES_AUDIO) {
        prefs[origine] = brut[origine] !== false; // absent → activé
    }
    prefs.transcription = brut.transcription === true; // transcription phonétique : masquée par défaut
    return prefs;
}

/**
 * Sauvegarde les préférences audio dans localStorage.
 * @param {Object} prefs  { recherche, lexies, exemples, mots } (booléens)
 */
export function sauvegarderPrefsAudio(prefs) {
    const àStocker = {};
    for (const origine of ORIGINES_AUDIO) {
        àStocker[origine] = prefs[origine] !== false;
    }
    àStocker.transcription = prefs.transcription === true;
    localStorage.setItem(LS_PREFS_AUDIO, JSON.stringify(àStocker));
}
